/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {GenericObject} from '@ion/core/src/types/entities';

/**
 * ACTIONS
 */
export const SET_QUERY_PARAMS   = 'SET_QUERY_PARAMS';
export const CLEAR_QUERY_PARAMS = 'CLEAR_QUERY_PARAMS';

/**
 * action that sets the pathname and query in the store
 */
export const setQueryParams = ({pathname, queryParams}) => ({
  type : SET_QUERY_PARAMS, pathname, queryParams
});

export const clearQueryParams = () => ({
  type : CLEAR_QUERY_PARAMS
});

/**
 * REDUCERS
 */

export interface QueryState {
  pathname: string;
  queryParams: GenericObject;
}

// defines the initial state for the reducer ...
export const initialState: QueryState = {
  pathname    : null,
  queryParams : null
};

// defines the reducers ...
const reducers = {
  [SET_QUERY_PARAMS] : (draft: QueryState, {pathname, queryParams}) => {
    draft.pathname    = pathname;
    draft.queryParams = queryParams;
  },
  [CLEAR_QUERY_PARAMS] : (draft: QueryState) => {
    draft.queryParams = null;
  }
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: QueryState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
